import React from "react"
import HeroSectionWrapper from "./shared/heroSectionWrapper/HeroSectionWrapper"
import HeroSectionContent from "./shared/heroSectionContent/HeroSectionContent"
import HeroSectionDescription from "./shared/heroSectionDescription/HeroSectionDescription"
import HeroImage from "./shared/heroImage/HeroImage"

const HomeHeroSection = ({ images }) => {
  return (
    <HeroSectionWrapper>
      <HeroSectionContent>
        <HeroSectionDescription />
        <HeroImage images={images} />
      </HeroSectionContent>
    </HeroSectionWrapper>
  )
}

export default HomeHeroSection
